<template>
    <el-menu class="navbar" mode="horizontal">
        <levelbar></levelbar>
        <tabs-view></tabs-view>
        <error-log v-if="log.length > 0" class="errLog-container" :logsList="log"></error-log>
        <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <messageRemind class="message-container" :toggleClick="showMessage" :isActive="sidebar.opened"></messageRemind>
        <!-- <screenfull class='screenfull'></screenfull> -->
        <el-dropdown class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
                <!-- <img class="user-avatar" :src="(avatar != '' ? avatar : defaultAvatar) + '?imageView2/1/w/80/h/80'"> -->
                <span class="user-name" style="margin-top:12px;"> {{name}}
                <i class="el-icon-caret-bottom"></i></span>
            </div>
            <el-dropdown-menu class="user-dropdown" slot="dropdown">
                <el-dropdown-item v-if="homeButtonVisible">
                    <span @click="toIndex" style="display:block;">首页</span>
                </el-dropdown-item>
                <!--
                <el-dropdown-item divided v-if="showMode()">
                	<span @click="setMode(1)" style="display:block;">常规模式</span>
                </el-dropdown-item>
                <el-dropdown-item divided v-if="showMode()">
                	<span @click="setMode(2)" style="display:block;">完整模式</span>
                </el-dropdown-item>
                -->
                <el-dropdown-item v-if="pwdChangeVisible" divided>
                    <span @click="changePwd" style="display:block;">修改密码</span>
                </el-dropdown-item>
                <el-dropdown-item divided>
                    <span @click="logout" style="display:block;">退出登录</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </el-menu>
</template>

<script>
import { globalConfig } from "static/config"
import { mapGetters } from 'vuex';
import Levelbar from './Levelbar';
import TabsView from './TabsView';
import Hamburger from 'components/Hamburger';
import Screenfull from 'components/Screenfull';
import ErrorLog from 'components/ErrLog';
import errLogStore from 'store/errLog';
import messageRemind from './messageRemind';

export default {
    components: {
        Levelbar,
        TabsView,
        Hamburger,
        ErrorLog,
        Screenfull,
        messageRemind,
    },
    data() {
        return {
            homeButtonVisible: !(globalConfig.evaVersion && localStorage.getItem('user')=='admin'),
            hiddenFrame:false,  // 隐藏登出框体
            logOutUrl:"",  //登出地址
            log: errLogStore.state.errLog,
            defaultAvatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
            pwdChangeVisible: false,
        }
    },
    computed: {
        ...mapGetters([
            'sidebar',
            'name',
            'avatar',
            'position',
            'email',
        ])
    },
    mounted() {
        this.pwdChangeVisible = !globalConfig.CASSWITCH;
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch('ToggleSideBar')
        },
        showMessage(){
            alert(1112);
        },
        logout() {
			this.$api.system.basic.userLogout({}).then((res) => {
			    if(res.status == 200){
			        localStorage.clear();

			        if (globalConfig.CASSWITCH) {
			            // let routeUrl = this.$router.resolve({
			            //     path: "/casLogoutAll"
			            // });
			            window.open(globalConfig.CASURL + '/logout?service=' + encodeURIComponent(globalConfig.DOMIN), '_self');
			        } else {
			            location.reload();
			        }
			    }else{
			        this.$message.error('登出失败，网络异常');
			    }
			}).catch((err) => {
			    console.log(err);
			    this.$message.error('登出失败，网络异常');
			});
        },
        changePwd() {
            // this.$router.push({ path: '/changePwd' });
            window.open(globalConfig.PSWURL, '_blank');
        },
        toIndex(){
            // let routeUrl = this.$router.resolve({
            //     path: "/building",
            //     query: {}
            // });
            // window.open(routeUrl.href, '_blank');
            this.$router.push('/homePage');
        },
        setMode(mode){
        	if (mode==0){
        		localStorage.removeItem('mode');
        	}else if(mode==1){
        		localStorage.setItem('mode',1);
        	}else if(mode==2){
        		localStorage.setItem('mode',2);
        	}
            //移除子系统参数
            localStorage.removeItem('subsystemId');
            localStorage.removeItem('subsystemName');
            localStorage.removeItem('expandMenuName');

        	let routeUrl = this.$router.resolve({
        		path: "/index",
        		query: {}
        	});
        	window.open(routeUrl.href, '_self');
        	location.reload();
        },
        showMode(){
             return true;

        	if (~localStorage.getItem('name').indexOf('管理员')){
        		return true;
        	}else{
        		return false;
        	}
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
        line-height: 58px;
        height: 50px;
        float: left;
        padding: 0 10px;
    }
    .message-container {
        position: absolute;
        line-height: 58px;
        height: 50px;
        float: right;
        right: 150px;
        padding: 0 10px;
    }
    .errLog-container {
        display: inline-block;
        position: absolute;
        right: 150px;
    }
    .screenfull {
        position: absolute;
        right: 160px;
        top: 16px;
        color: red;
    }
    .avatar-container {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 35px;
        .avatar-wrapper {
            cursor: pointer;
            height: 50px;
            position: relative;
            .user-avatar {
                margin-top: 5px;
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
            .user-name {
                top: -12px;
                display: inline-block;
                font-size: 14px;
                position: relative;
            }
            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 20px;
                font-size: 12px;
            }
        }
    }
}
.el-dropdown-menu{
    left: auto!important;
    top: 38px!important;
    right: 13px!important;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?6c66c48c